import Helper from './Helper';

class Accordion {
  constructor(config = {}) {
    const {
      accordions,
    } = config;
    this.accordions = Array.prototype.slice.call(document.querySelectorAll(accordions));
    this.currentEl = null;
    if(this.accordions && this.accordions.length !== 0){
      this.checkForAnchor(accordions);
      this.bindEvents();
    }
  }

  checkForAnchor(accordions){
    if(window.location.hash) {
      const anchor = window.location.hash;
      // console.log(`.ns-anchor${anchor}`);
      const currentAnchor = document.querySelector(`.ns-anchor${anchor}`);
      const parentAccordion = currentAnchor.parentElement.previousElementSibling;
      // console.log(parentAccordion);
      parentAccordion.classList.add('active');
      Helper.slideOpen(parentAccordion.nextElementSibling, true);
      currentAnchor.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }
  }

  bindEvents() {
    this.accordions.forEach(el => {
      el.addEventListener('click', (e) => {
        if(el.classList.contains('active')){
          Helper.slideClose(el.nextElementSibling);
          el.classList.remove('active');
        } else{
          el.classList.add('active');
          Helper.slideOpen(el.nextElementSibling, true);
        }
      });
    });
  }

}

export default Accordion;
